import { Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { EnAutorizacionDiligenciaFormComponent } from '../en-autorizacion-diligencia-form/en-autorizacion-diligencia-form.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EnAutorizacionDiligenciaCreateService } from './en-autorizacion-diligencia-create.service';
import { EvkCreateComponentBase, MessageCrudService } from '@evomatik/evk-common';
import { Observable } from 'rxjs';
import {DiligenciaTareaModel} from "../../../../../../../diligencia/models/diligencia-tarea.model";

@Component({
    selector: 'lib-autorizacion-diligencia-create',
    templateUrl: './en-autorizacion-diligencia-create.component.html',
    styleUrls: ['./en-autorizacion-diligencia-create.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class EnAutorizacionDiligenciaCreateComponent extends EvkCreateComponentBase<any> implements OnInit {

    constructor(
        public createService: EnAutorizacionDiligenciaCreateService,
        public messagesCrudService: MessageCrudService,
        public dialogRef: MatDialogRef<EnAutorizacionDiligenciaCreateComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        super(createService, messagesCrudService);
        this.diligencia = data.diligencia;
        this.generarFormato = data.formatoAutomatico;
        this.configAutorizador = data.configAutorizador;
        this.origen = data.origen;
        this.organizacionOrigen = data.organizacionOrigen;

    }

    public get formValid() {
        return this.form !== undefined && this.form.valid;
    }

    @ViewChild(EnAutorizacionDiligenciaFormComponent, {static: false})
    set formComponent(autorizacionForm: EnAutorizacionDiligenciaFormComponent) {
        this.form = autorizacionForm.form;
    }

    public diligencia: DiligenciaTareaModel;

    public configAutorizador: any;

    public origen: string;

    public generarFormato: boolean;

    public organizacionOrigen: any;

    protected beforeSave = (data: any) => {
        return new Observable<DiligenciaTareaModel>(
            response => {
                this.diligencia.unidadDestino = this.form.controls.organizacion.value;
                this.diligencia.usuarioDestino = this.form.controls.usuarioAsignado.value !== '' ? this.form.controls.usuarioAsignado.value : null;
                response.next(this.diligencia);
            }
        );
    }

    ngOnInit() {
        this.createService.evkOnDoneSave = this.closeDialog;
    }

    public closeDialog = () => {
        this.dialogRef.close({data: true});
    }
}
